import { useQuery } from 'react-query'

import { QueryKeys } from '../../../enums/queryKeys'
import { getDaybookTransaction } from '../query-api'

export const useFetchDaybookTransaction = (daybookTransactionId?: string) => {
  const { data, isLoading } = useQuery(
    [QueryKeys.DaybookTransaction, daybookTransactionId],
    () => getDaybookTransaction({ daybookTransactionId: daybookTransactionId as string }),
    { enabled: !!daybookTransactionId },
  )

  return { daybookTransaction: data?.daybookTransaction, isLoading }
}
